import { render } from "./TransaksiPerjawatan.vue?vue&type=template&id=18228225&ts=true"
import script from "./TransaksiPerjawatan.vue?vue&type=script&lang=ts"
export * from "./TransaksiPerjawatan.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__